import moment from "moment";
import { DATE_FORMATS, formatDate } from "../../../services/date-and-time.utils";
import { HOLIDAY_TYPES, Holiday, HolidayFormValues } from "./types";

export function formatHolidayDate(holiday: Holiday, year = new Date().getFullYear()): string {
  if (holiday.type === HOLIDAY_TYPES.ONE_TIME && holiday.date) {
    return formatDate(holiday.date, DATE_FORMATS.fullDate);
  }

  if (holiday.month && holiday.day) {
    const annualDate = `${year}-${String(holiday.month).padStart(2, "0")}-${String(
      holiday.day
    ).padStart(2, "0")}`;
    return formatDate(annualDate, DATE_FORMATS.fullDate);
  }

  return "—";
}

export function emptyHolidayForm(): HolidayFormValues {
  return {
    name: "",
    type: HOLIDAY_TYPES.ANNUAL,
    month: "",
    day: "",
    date: "",
    active: true,
  };
}

export function holidayToFormValues(holiday: Holiday): HolidayFormValues {
  return {
    name: holiday.name || "",
    type: holiday.type || HOLIDAY_TYPES.ANNUAL,
    month: holiday.month != null ? String(holiday.month) : "",
    day: holiday.day != null ? String(holiday.day) : "",
    date: holiday.date || "",
    active: holiday.active !== false,
  };
}

export function buildHolidayPayload(form: HolidayFormValues) {
  const payload: Record<string, any> = {
    name: form.name.trim(),
    type: form.type,
    countryCode: "US",
    active: form.active,
  };

  if (form.type === HOLIDAY_TYPES.ANNUAL) {
    payload.month = parseInt(form.month, 10);
    payload.day = parseInt(form.day, 10);
  } else {
    payload.date = form.date;
  }

  return payload;
}

export function validateHolidayForm(form: HolidayFormValues): string {
  if (!form.name.trim()) return "Name is required";

  if (form.type === HOLIDAY_TYPES.ANNUAL) {
    const month = parseInt(form.month, 10);
    const day = parseInt(form.day, 10);
    if (!month || month < 1 || month > 12) return "Valid month is required";
    if (!day || day < 1 || day > 31) return "Valid day is required";
    const probe = moment({ year: 2024, month: month - 1, day });
    if (!probe.isValid() || probe.date() !== day) return "Invalid month/day";
    return "";
  }

  if (!form.date) return "Date is required";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(form.date)) return "Invalid date format";
  return "";
}
